module.exports = __webpack_public_path__ + "img/kv_img_3.be986810.png";